import axiosInstance from "@/composables/axios-instance";

const state = {
  dashboard: {},
};

const getters = {
  getDashboardData(state) {
    return state.dashboard;
  },
};

const mutations = {
  setDashboardData(state, data) {
    state.dashboard = data;
  },
};

const actions = {
  getDashboardDataFromApi({ commit }) {
    return axiosInstance.get("/dashboard/").then(response => {
        commit("setDashboardData", response.data);
      }).catch((error) => {
        console.error(error);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
